import { useTranslation } from "react-i18next";
import { Box } from "@mantine/core"
import { Button } from "components"
import { StatusActions } from "types";

const ApprovedStatusActions = ({ onClick, isLoading }: StatusActions) => {
  const { t } = useTranslation();
  
  return (
    <>
      <Box ml={'sm'}>
        <Button size={'compact-md'} onClick={() => onClick('SIGNING')} loading={isLoading}>
          {t('credit.status.action.SIGNING')}
        </Button>
      </Box>
      <Box ml={'sm'}>
        <Button size={'compact-md'} variant={'outline'} color={'var(--mantine-color-error)'} onClick={() => onClick('CANCELED')} loading={isLoading}>
          {t('credit.status.action.CANCELED')}
        </Button>
      </Box>
    </>
  )
}

export default ApprovedStatusActions;